/* global location */

import { Module } from 'wrapper6'
import ProductService from '../services/_product-service'
import MiniCart from './_mini_cart'

export default class SelectVariations extends Module {
  ready () {
    this.variationsForm = document.getElementsByClassName('variations_form')[0]
    if (!this.variationsForm) return

    this.selectBoxes = this.variationsForm.querySelectorAll('select[data-attribute_name]')
    this.attributes = []
    this.productId = document.getElementsByName('product_id')[0].value
    this.button = document.querySelector('.single_add_to_cart_button')
    this.button.classList.add('wc-variation-selection-needed')
    this.button.setAttribute('type', 'button')

    for (let i = 0; i < this.selectBoxes.length; i++) {
      this.attributes.push(this.selectBoxes[i].name)
      this.selectBoxes[i].addEventListener('change', () => {
        this.isAnySelectsEmpty()
        this.updatePrice()
      })
    }

    this.button.addEventListener('click', async () => {
      if (this.button.classList.contains('wc-variation-selection-needed')) {
        return null
      }

      this.quantity = this.variationsForm.querySelector('.quantity input').value

      await this.addToCart()
    })
    this.isAnySelectsEmpty()
    this.updatePrice()
  }

  isAnySelectsEmpty () {
    let selected = 0

    for (let i = 0; i < this.selectBoxes.length; i++) {
      if (this.selectBoxes[i].value !== '') {
        selected++
      }
    }
    if (this.selectBoxes.length === selected) {
      this.button.classList.remove('wc-variation-selection-needed')
      return false
    }
    this.button.classList.add('wc-variation-selection-needed')
    return true
  }

  async addToCart () {
    this.button.classList.add('loading')
    const addToCart = await ProductService.addVariationToCart(
      this.productId,
      document.getElementsByName('variation_id')[0].value,
      this.quantity
    )
    if (addToCart.data.added) {
      MiniCart.updateCartContents(addToCart.data.html)
    } else {
      location.reload()
    }
    this.button.classList.remove('loading')
  }

  updatePrice () {
    const selectedTerms = {}
    for (let i = 0; i < this.selectBoxes.length; i++) {
      selectedTerms[this.selectBoxes[i].name] = this.selectBoxes[i].value
    }

    this.variants = JSON.parse(this.variationsForm.dataset.product_variations)
    for (let i = 0; i < this.variants.length; i++) {
      const attributes = this.variants[i].attributes
      let foundAttributes = 0
      for (let j = 0; j < Object.keys(attributes).length; j++) {
        if (attributes[Object.keys(attributes)[j]] === selectedTerms[Object.keys(selectedTerms)[j]]) {
          foundAttributes++
        }
      }
      if (Object.keys(selectedTerms).length === foundAttributes) {
        document.querySelectorAll('div.price')[0].innerHTML = this.variants[i].price_html
        return
      }
    }
  }
}
